var map = {
	"./astrid-logo.png": 7534,
	"./images/brush-stroke.svg": 558,
	"./images/marbled-gold.svg": 6712,
	"./images/orange.jpg": 5210,
	"./images/purple-hair.jpg": 596,
	"./images/single-stroke.svg": 6407,
	"./images/trim-hair.png": 3753,
	"./images/trim.png": 5778,
	"./images/two-tone-hair.jpg": 4966,
	"./images/womansilhoutte.svg": 6368,
	"./services": 5950,
	"./services.js": 5950
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;